export const playerInPending = state => {
  return state.room.pending
}

export const playerInLobby = state => {
  return state.room.lobby
}



// WEBPACK FOOTER //
// ./src/store/getters.js